import { NEW_USER_CHANNEL_PREFIX, USER_CHANNEL_PREFIX } from '../constants';

function createUserChannelName(userName) {
  return `${USER_CHANNEL_PREFIX}${userName}`;
}

function createNewOmsUserChannelName(userName) {
  return `${NEW_USER_CHANNEL_PREFIX}${userName}`;
}

export { createUserChannelName, createNewOmsUserChannelName };
